'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports['default'] = APIQuery;

var _immutable = require('immutable');

var QueryContainer = _immutable.Record({
  data: _immutable.fromJS({}),
  errors: null,
  pending: false,
  fetched: false
});

function APIQuery() {
  var input = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  return new QueryContainer(_extends({}, input, {
    data: _immutable.fromJS(input.data)
  }));
}

module.exports = exports['default'];